export default __webpack_public_path__ + "static/media/IconDesc_Silica.256.4f402e31.png";